function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#231F20",
  d: "M4.949,14.98c-0.083-0.072-0.165-0.148-0.244-0.227 c-1.871-1.871-1.831-4.945,0.089-6.865c1.92-1.92,4.994-1.96,6.865-0.089c0.929,0.929,1.387,2.155,1.377,3.389 c1.065-2.42,0.637-5.31-1.302-7.248C9.192,1.398,5.018,1.452,2.408,4.062c-2.609,2.609-2.663,6.784-0.122,9.326 C3.054,14.155,3.971,14.685,4.949,14.98z"
});

var Svg4 = function Svg4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000143617183357817037130000002557260287089233058_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.02 17",
    enableBackground: "new 0 0 14.02 17",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4.58326fda.svg";
export { ForwardRef as ReactComponent };